$(document).ready(function() {
    setTimeout(function() {
        $('#main-collection-filters').fadeOut(300, function() {
            $(this).appendTo('.cloud-search-page-controls__filters').fadeIn(300);
        });
    }, 2000);
});



$('.testimonial-container').slick({
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true 
      }
    },
    {
      breakpoint: 786,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true 
      }
    }
  ]
});





